<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ promotion.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.title
                        }}</CCol>
                    </CRow>

                    <div
                        v-if="(promotion.restaurants && promotion.restaurants.length > 0) && allRestaurants.length"
                        class="flex items-center mt-3 mb-3"
                    >
                        <span class="w-1/4 font-bold">Рестораны</span>
                        <span class="w-2/4">
                            <span
                                v-for="restaurant in promotion.restaurants"
                                :key="restaurant"
                                class="text-purple-700 cursor-pointer hover:underline mr-3"
                                :title="allRestaurants[restaurant].title"
                                @click="$router.push(`/restaurants/${allRestaurants[restaurant].id}`)"
                            >
                                {{ allRestaurants[restaurant].title }}
                            </span>
                        </span>
                    </div>
                    
                    <div
                        v-if="(promotion.grocers && promotion.grocers.length > 0) && allGrocers.length"
                        class="flex items-center mt-3 mb-3"
                    >
                        <span class="w-1/4 font-bold">Магазины продуктов</span>
                        <span class="w-2/4">
                            <span
                                v-for="grocer in promotion.grocers"
                                :key="grocer"
                                class="text-purple-700 cursor-pointer hover:underline mr-3"
                                :title="allGrocers[grocer].title"
                                @click="$router.push(`/grocers/${allGrocers[grocer].id}`)"
                            >
                                {{ allGrocers[grocer].title }}
                            </span>
                        </span>
                    </div>

                    <div
                        v-if="(promotion.pharmacy && promotion.pharmacy.length > 0) && allPharmacies.length"
                        class="flex items-center mt-3 mb-3"
                    >
                        <span class="w-1/4 font-bold">Аптеки</span>
                        <span class="w-2/4">
                            <span
                                v-for="pharmacy in promotion.pharmacy"
                                :key="pharmacy"
                                class="text-purple-700 cursor-pointer hover:underline mr-3"
                                :title="allPharmacies[pharmacy].title"
                                @click="$router.push(`/pharmacies/${allPharmacies[pharmacy].id}`)"
                            >
                                {{ allPharmacies[pharmacy].title }}
                            </span>
                        </span>
                    </div>

                    <div
                        v-if="(promotion.assistants && promotion.assistants.length > 0) && allAssistants.length"
                        class="flex items-center mt-3 mb-3"
                    >
                        <span class="w-1/4 font-bold">Помощники</span>
                        <span class="w-2/4">
                            <span
                                v-for="assistant in promotion.assistants"
                                :key="assistant"
                                class="text-purple-700 cursor-pointer hover:underline mr-3"
                                :title="allAssistants[assistant].title"
                                @click="$router.push(`/assistants/${allAssistants[assistant].id}`)"
                            >
                                {{ allAssistants[assistant].title }}
                            </span>
                        </span>
                    </div>

                    <div v-if="(promotion.entities && promotion.entities.length) && allEntityTypes.length">
                        <div
                            v-for="type of allEntityTypes"
                            :key="type.id"
                            class="flex items-center mt-3 mb-3"
                        >
                            <span v-if="type.id" class="w-1/4 font-bold">{{ type.title ? type.title : 'Сервис' }}</span>
                            <span v-if="type.services && type.services.length" class="w-2/4">
                                <span
                                    v-for="entity of type.services"
                                    :key="entity.id"
                                    class="text-purple-700 cursor-pointer hover:underline mr-3"
                                    :title="entity.title"
                                    @click="$router.push(`/entities/${type.code}/${entity.id}`)"
                                >
                                    {{ entity.title }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <Schedule class="font-bold"  :schedule="schedule" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Тип</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotionTypeTitle(promotion.type)
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.discount }} %</CCol
                        >
                    </CRow>
                    <CRow
                        v-if="promotion.orders_quantity"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Количество первых заказов в заведении по акции</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.orders_quantity }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка от ресторана (%) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.entity_discount_percent ? promotion.entity_discount_percent + "%" : "" }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скидка от ресторана (руб.) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.entity_discount_sum ? promotion.entity_discount_sum + " р." : "" }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Комиссия МИРСИТИ (%) </CCol>
                        <CCol
                            sm="9"
                            class="col-form-label"
                        >{{ promotion.mircity_commission ? promotion.mircity_commission + "%" : "" }}</CCol
                        >
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Дата начала</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.date_start
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Дата окончания</CCol
                        >
                        <CCol sm="9" class="col-form-label">{{
                            promotion.date_finish
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время начала</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            promotion.time_from
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Время окончания</CCol
                        >
                        <CCol sm="9" class="col-form-label">{{
                            promotion.time_to
                        }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            sm="3"
                            class="col-form-label"
                        >Неограничено (срок)</CCol
                        >
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.unlimited)">
                                &nbsp;{{
                                    promotion.unlimited ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                   <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Тип доставки</CCol>
                        <CCol sm="9" class="col-form-label">
                            {{ labelDeliveryType(promotion.delivery_type) }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Учитывать при интеграции</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.accounting_in_integration)">
                                &nbsp;{{
                                    promotion.accounting_in_integration ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(promotion.enabled)">
                                &nbsp;{{
                                    promotion.enabled ? "Да" : "Нет"
                                }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import PromotionsTabLinks from '@/components/promotions/CommonPromotionsTabLinks';
    import { promotionTypeTitle } from '../../../utils/promotion-views';
    import Schedule from '@/components/ScheduleWorkPromotion';
    const { DELIVERY_TYPE } = require('../../../utils/order');

    export default {
        name: 'Promotion',

        components: {
            PromotionsTabLinks,
            Schedule,
        },

        data() {
            return {
                schedule: undefined,
                promotion: {},
                allRestaurants: [],
                allGrocers: [],
                allPharmacies: [],
                allAssistants: [],
                allEntityTypes: [],
            };
        },

        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get('/common-promotions/' + id)
                .then(resp => {
                    this.promotion = resp.data;
                    if(resp.data.schedule.length != 0) {
                        this.schedule = resp.data.schedule;
                    }

                    if (this.promotion.date_start) {
                        this.promotion.date_start = moment(this.promotion.date_start).format('YYYY-MM-DD');
                    }
                    if (this.promotion.date_finish) {
                        this.promotion.date_finish = moment(this.promotion.date_finish).format('YYYY-MM-DD');
                    }
                    this.promotion.time_from = this.promotion.time_from
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_from + ' GMT+0000').local().format('HH:mm:ss')
                        : null;
                    this.promotion.time_to = this.promotion.time_to
                        ? moment('Mon Jun 28 2021 ' + this.promotion.time_to + ' GMT+0000').local().format('HH:mm:ss')
                        : 0;
                })
                .catch(e => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных');
                })
                
            try {
                await this.initBusiness();
            } catch(e) {
                 this.$root.$emit('showError', 'Ошибка загрузки данных.');
            }

            // try {
            //     const resp = await Vue.axios.get(`/common-promotions/${parseInt(this.$route.params.id)}`);
                
            //     this.promotion = resp.data;
            //     if (this.promotion.date_start) {
            //         this.promotion.date_start = moment(this.promotion.date_start).format('YYYY-MM-DD');
            //     }
            //     if (this.promotion.date_finish) {
            //         this.promotion.date_finish = moment(this.promotion.date_finish).format('YYYY-MM-DD');
            //     }
            //     this.promotion.time_from = this.promotion.time_from
            //         ? moment('Mon Jun 28 2021 ' + this.promotion.time_from + ' GMT+0000').local().format('HH:mm:ss')
            //         : null;
            //     this.promotion.time_to = this.promotion.time_to
            //         ? moment('Mon Jun 28 2021 ' + this.promotion.time_to + ' GMT+0000').local().format('HH:mm:ss')
            //         : 0;
            //     await this.initBusiness();
            // } catch (error) {
            //     this.$root.$emit('showError', 'Ошибка загрузки данных.');
            // }
        },

        methods: {
            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },
            async initBusiness() {
                // Restaurants
                var result = (await this.axios.get('/restaurants')).data;
                const restaurants = [];
                result.forEach(restaurant => {
                    restaurants[restaurant.id] = restaurant;
                });
                this.allRestaurants = restaurants;

                // Grocers
                result = (await this.axios.get('/grocers')).data;
                const grocers = [];
                result.forEach(grocer => {
                    grocers[grocer.id] = grocer;
                });
                this.allGrocers = grocers;

                // Pharmacies
                result = (await this.axios.get('/pharmacies')).data;
                const pharmacies = [];
                result.forEach(pharmacy => {
                    pharmacies[pharmacy.id] = pharmacy;
                });
                this.allPharmacies = pharmacies;

                // Assistants
                result = (await this.axios.get('/assistants')).data;
                const assistants = [];
                result.forEach(assistant => {
                    assistants[assistant.id] = assistant;
                });
                this.allAssistants = assistants;

                // Entities
                this.allEntityTypes = (await this.axios.get('/entities-type')).data;

                this.allEntityTypes = await Promise.all(this.allEntityTypes.map(async type => {
                    const entities = await this.axios.get(`/entities/${type.code}`);
                    type.services = entities.data;
                    return type;
                }));

                this.allEntityTypes = this?.allEntityTypes?.map(type => {
                    if (type?.services?.length) {
                        type.services = type.services.filter(entity => this.promotion?.entities?.includes(entity.id));
                    }
                    return type;
                });
                this.allEntityTypes = this?.allEntityTypes?.filter(type => !!type?.services?.length);
            },
            goBack() {
                this.$router.push({ path: '/promotions' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            promotionTypeTitle(type) {
                return promotionTypeTitle(type);
            }
        },
    };
</script>
